import { Box, Typography, Divider } from "@mui/material";
import DataTable from "../../CommonComponents/common/datatable/DataTable";
import { useEffect } from "react";

const DataTableWrapper = ({
  title = "",
  columns = [],
  filters = [],
  height = 400,
  fetchRows,
  defaultPageSize = 10,
  rows = [],
  disableSideBar = false,
  onColumnFilterChanged,
  initialFilterModel
}) => {
  // const [tempSelectedAttributes, setTempSelectedAttributes] = useState(columns);
  //   const [availableAttributes, setAvailableAttributes] = useState([]);

  //   useEffect(() => {
  //     const selectedFields = tempSelectedAttributes.map(attr => attr.field);
  //     const unselected = columns.filter(col => !selectedFields.includes(col.field));
  //     setAvailableAttributes(unselected);
  //   }, [tempSelectedAttributes, columns]);

   useEffect(() => {
    // When the page loads: lock the body
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  
    // When you leave the page: unlock it for other pages
    return () => {
      document.body.style.overflow = "auto";
      document.documentElement.style.overflow = "auto";
    };
  }, []);

  return (
    <Box
       sx={{
      display: "flex",
      flexDirection: "column",
      height: "100%", // This fills the InventoryTable Box
      backgroundColor: "#fff",
      borderRadius: "5px",
      overflow: "hidden", // Ensures nothing leaks out
    }}
    >
      {/* Header */ }
     <Box sx={{ p: 1, flexShrink: 0 }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          align="left"
          sx={ { flexGrow: 1, fontSize: "1rem", marginLeft: "12px" } }
        >
          {/* Removed, handled in HeaderBar */ }
        </Typography>

        <Box display="flex" alignItems="center">
          {/* <IconButton
            aria-label="filter"
            size="small"
            sx={{ color: filterToggle ? 'primary.main' : 'primary.secondary' }}
            onClick={() => setFilterToggle(!filterToggle)}
          >
            <FilterAltOutlinedIcon fontSize="small" />
          </IconButton> */}
        </Box>
      </Box>

     <Divider sx={{ flexShrink: 0 }} />

      {/* Filters */ }
      {/* {filterToggle && filters.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 2,
            p: 1,
            bgcolor: '#f5f7fa',
            borderRadius: 2,
          }}
        >
          <Typography variant="body2" sx={{ mr: 2, fontWeight: 500 }}>
            Filtered by:
          </Typography>

          {filters.map((filter) => (
            <Box
              key={filter.value}
              sx={{
                bgcolor: '#e3f2fd',
                color: 'primary.main',
                px: 1.5,
                py: 0.5,
                borderRadius: 2,
                fontSize: '0.75rem',
                fontWeight: 500,
                display: 'inline-flex',
                alignItems: 'center',
                mr: 1,
              }}
            >
              {filter.label}
              <IconButton
                size="small"
                sx={{ ml: 0.5, p: '2px', color: 'primary.main' }}
                aria-label={`remove ${filter.label}`}
                onClick={filter.onRemove}
              >
                <span style={{ fontSize: '1rem', lineHeight: 1 }}>&times;</span>
              </IconButton>
            </Box>
          ))}

          <Typography
            variant="body2"
            sx={{
              color: 'primary.main',
              cursor: 'pointer',
              fontWeight: 500,
              '&:hover': { textDecoration: 'underline' },
            }}
            onClick={() => filters.forEach((f) => f.onRemove())}
          >
            Clear all
          </Typography>
        </Box>
      )} */}

      {/* Table */ }
      <Box sx={{
        flex: 1,           
        minHeight: 0,      
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflow: "hidden" // Prevents the table from pushing the footer down
      }}>
      <DataTable
        columns={ columns }
        filters={ filters }
        height={ height }
        fetchRows={ fetchRows }
        defaultPageSize={ defaultPageSize }
        rows={ fetchRows ? undefined : rows }
        disableSideBar={ disableSideBar }
        onColumnFilterChanged={ onColumnFilterChanged }
        initialFilterModel={ initialFilterModel }
      />
      </Box>
    </Box>
  );
};

export default DataTableWrapper;
